import './SelectableFilterEditor.less';
import React from "react";
import {jsonCopy} from "../../../../utils/json";
import {translate} from "../../../../i18n";
import arrayToStringWithCount from "../../config/arrayToStringWithCount";
import Icon from "../../../icon/Icon";
import {FilterEditorTemplate} from "../../templates/filter-editor/FilterEditorTemplate";
import Dropdown from "../../../dropdown/Dropdown";


export default class SelectableFilterEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.defaultValue
                ? jsonCopy(props.optSingle ? [props.defaultValue] : props.defaultValue)
                : [],
            error: null,
            dropdownShown: false
        };

        this.inlineEl = null;
    }

    componentDidMount() {
        this.validate();

        this.setState({
            dropdownShown: true
        });
    }

    toggleSelection = (id) => {
        const {optSingle} = this.props;
        const { value } = this.state;
        const index = value.indexOf(id);

        if (optSingle) {
            value.length = 0;

            if (index === -1) {
                value.push(id);
            }
        } else {
            if (index > -1) {
                value.splice(index, 1);
            } else {
                value.push(id);
            }
        }

        this.setState({ value }, () => {
            this.validate();
        });
    };

    validate = () => {
        const { optSingle } = this.props;
        const { value } = this.state;
        /** @type {LabelMap} */
        const options = this.props.options;
        if (options.items.length === 0) {
            this.setState({
                error: translate('Empty list')
            });
        }
        else if (!value || value.length === 0) {
            this.setState({
                error: optSingle ? translate('Select one') : translate('Select one or more')
            });
        }
        else {
            this.setState({
                error: null
            });
        }
    };

    submit = () => {
        const { update, optSingle } = this.props;
        const { value, error } = this.state;

        if (error !== null) {
            return;
        }

        update(this.getOperator(), optSingle ? value[0] : value);
    };

    getOperator = () => {
        const {optSingle} = this.props;

        if (optSingle) {
            return 'is';
        }

        return 'in_list';
    };

    renderInputComponent = () => {
        const { value, dropdownShown } = this.state;
        const { optSingle } = this.props;

        /** @type {LabelMap} */
        const options = this.props.options;

        const selectedOptions = options.items.filter(option => value.includes(option.value));

        const valueText = optSingle
            ? (selectedOptions.length > 0 ? selectedOptions[0].label : '')
            : arrayToStringWithCount(selectedOptions.map(option => option.label));

        return <div
            className="value-input"
            ref={el => this.inlineEl = el}
        >
            <div
                className="selected-summary"
                aria-label={valueText}
                aria-controls="tooltip-is-plain-text-content"
            >
                {valueText}
            </div>
            {
                dropdownShown &&
                <Dropdown
                    name="selectable-filter-editor"
                    opener={this.inlineEl}
                >
                    {
                        contentViewableMaxHeight => <>
                            {
                                options.items.length > 0 &&
                                <div className="option-list">
                                    <div className="dropdown-scroll-container">
                                        <div
                                            className="dropdown-scroll-view"
                                            style={{
                                                maxHeight: contentViewableMaxHeight + 'px'
                                            }}
                                        >
                                            {
                                                options.items
                                                       .map(option => (
                                                           <div key={option.value}
                                                                className={'option-item' + (value.includes(option.value) ? ' selected' : '')}
                                                                onClick={() => this.toggleSelection(option.value)}
                                                           >
                                                               <span className="label">{option.label}</span>
                                                               <Icon name="tick"/>
                                                           </div>
                                                       ))
                                            }
                                        </div>
                                    </div>

                                </div>
                            }
                            {
                                options.items.length === 0 &&
                                <div className="empty-list">
                                    {translate('Empty list')}
                                </div>
                            }
                        </>
                    }
                </Dropdown>
            }
        </div>;
    };

    render() {
        const { error } = this.state;
        const { fieldName } = this.props;

        return <div className="selectable-filter-editor">
            <FilterEditorTemplate
                fieldName={fieldName}
                operator={this.getOperator()}
                inputComponent={this.renderInputComponent()}
                error={error}
                apply={this.submit}
            />
        </div>;
    }
}
